/* Crown motion layer: scroll-in reveals for the storefront.
 *
 * Contract with crown-lulu-port.css: the stylesheet pre-hides the exact
 * selectors listed below, but ONLY when <html> carries the `crown-motion`
 * class (added inline in theme.liquid before first paint). This script's
 * only job is to add `crown-reveal-in` as elements enter the viewport —
 * so with JS disabled or reduced motion requested, nothing is ever hidden.
 *
 * Elements revealed in the same observer callback stagger 0/60/120…ms,
 * which makes rows cascade as they scroll in without per-element delays.
 */
(function () {
  var root = document.documentElement;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    root.classList.remove('crown-motion');
    return;
  }

  var GROUPS = [
    '.crown-lulu-product-grid',
    '.crown-lulu-rail__track',
    '.crown-lulu-lanes__grid',
    '.crown-lulu-finder__models',
    '.crown-lulu-finder__systems',
    '.crown-lulu-highlights__grid',
    '.crown-lulu-footer__top',
    '.crown-lulu-cart-form__items',
    '.crown-lulu-contact-page__grid',
  ];
  var SINGLES = [
    '.crown-lulu-section-heading',
    '.crown-lulu-catalog__head',
    '.crown-lulu-hero__copy',
    '.crown-lulu-intro',
    '.crown-lulu-rail__heading',
    '.crown-lulu-product-gallery',
    '.crown-lulu-product-buy',
    '.crown-lulu-cart-summary',
    '.crown-lulu-category-card',
    '.crown-lulu-empty',
  ];

  var observer = new IntersectionObserver(
    function (entries) {
      var batch = 0;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.style.setProperty('--crown-reveal-delay', Math.min(batch, 9) * 60 + 'ms');
        batch += 1;
        el.classList.add('crown-reveal-in');
        observer.unobserve(el);
      });
    },
    { rootMargin: '0px 0px -7% 0px', threshold: 0.05 }
  );

  function watch(el) {
    if (!el || el.dataset.crownReveal) return;
    el.dataset.crownReveal = '1';
    observer.observe(el);
  }

  function scan(scope) {
    SINGLES.forEach(function (sel) {
      scope.querySelectorAll(sel).forEach(watch);
    });
    GROUPS.forEach(function (sel) {
      scope.querySelectorAll(sel).forEach(function (parent) {
        Array.prototype.forEach.call(parent.children, watch);
        if (!parent.dataset.crownRevealGroup) {
          parent.dataset.crownRevealGroup = '1';
          new MutationObserver(function (muts) {
            muts.forEach(function (m) {
              Array.prototype.forEach.call(m.addedNodes, function (node) {
                if (node.nodeType === 1) watch(node);
              });
            });
          }).observe(parent, { childList: true });
        }
      });
    });
  }

  var start = function () { scan(document); };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
